<template>
    <div class="PjanNavigationbar">
        <div class="m-title under-ico">
            旗下调解员
        </div>
        <div class="min" v-for="(item, index) in List" :key="index">
            <div class="character">
                <div class="charge-mark">
                    <!-- <img class="charge-img" src="../../assets/image/free.png"> -->
                </div>
                <span class="spanImg">
                    <img :src="item.imgName" alt="">
                </span>
                <div class="name">
                    <em class="text-ellipsis">{{ item.name }}</em>
                    <!-- <div class="identify no-identify"><b>待法院认证</b></div> -->
                </div>
            </div>
            <div class="data">
                <span>
                    <em>
                        {{ item.MediationSuccessful }}
                    </em>
                    调解成功</span>
                <span class="st"></span>
                <span>
                    <em>
                        {{ item.NumberOfCases }}
                    </em>案件数量</span>
            </div>
            <div class="org-include">
                <h3>所属机构</h3>
                <p>枣强曙光商事调解中心</p>
            </div>
            <div class="skills">
                <h3>擅长领域</h3>
                <div class="skill-type">
                    <span v-for="(i, n) in item.data" :key="n">{{ i }}</span>
                </div>
            </div>
            <div v-if="item.hrefs">
                <a href="https://tiaojie.court.gov.cn/organ/QutAQStGusQfnhRe" data-mediator-id="KbJTIcRcnzpCUuwQ"
                    target="_blank" class="see-now">立即查看</a>
            </div>
        </div>
    </div>
</template>
<script>
import { dataInJs } from "./Data";
export default {
    data() {
        return {
            resolution: '',
            List: dataInJs(),
        }
    },
    mounted() {
        if (JSON.parse(sessionStorage.getItem("resolution"))) {
            this.resolution = JSON.parse(sessionStorage.getItem("resolution"))
        }
    },
    created() {
        console.log(this.List);
    },
}
</script>
<style lang="less" scoped>
.PjanNavigationbar {
    width: 100%;

    .m-title {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #f4f4f4;
        padding-left: 47px;
        font-size: 16px;
        font-weight: 700;
    }

    .under-ico {
        background: url(../../assets/image/under-ico.png) no-repeat 18px center;
        padding-left: 43px;
    }

    .tab_content {
        p {
            width: 250px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .tab_sent:hover p,
        .tab_sent:hover span {
            color: #BE1A0F;
        }
    }

    img {
        width: 100%;
        text-align: center;
        margin: 0 auto;
    }

    .min {
        margin-top: 3%;
        float: left;
        width: 246px;
        height: 383px;
        border: 1px solid #e5e5e5;
        -moz-border-radius: 8px;
        -webkit-border-radius: 8px;
        border-radius: 8px;
        margin-left: 15px;
        margin-bottom: 15px;

        .character {
            position: relative;
            left: 0;
            top: 0;
            height: 115px;
            width: 100%;
            border-bottom: 1px solid #f4f4f4;

            .charge-mark {
                position: absolute;
                left: -2px;
                top: -2px;
                width: 50px;
                height: 50px;
            }

            .charge-img {
                width: 100%;
                height: 100%;
            }

            .spanImg {
                width: 80px;
                height: 80px;
                -moz-border-radius: 50%;
                -webkit-border-radius: 50%;
                border-radius: 50%;
                float: left;
                overflow: hidden;
                background-color: #d4d4d4;
                margin: 15px 25px 0 17px;

                img {
                    width: 80px;
                    height: 80px;
                }
            }

            .name {
                margin-top: 17px;
                float: left;
                width: 100px;

                em {
                    height: 68px;
                    display: block;
                    width: 100px;
                    overflow: hidden;
                    font-size: 18px;
                    font-weight: 700;
                    line-height: 68px;

                    .text-ellipsis {
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }

                .identify {
                    width: 100px;
                    height: 20px;
                    line-height: 20px;
                    -moz-border-radius: 3px;
                    -webkit-border-radius: 3px;
                    border-radius: 3px;
                    padding-top: 1px;
                    padding-right: 1px;
                    float: left;



                    b {
                        width: 76px;
                        height: 18px;
                        background-color: #fff;
                        margin-left: 23px;
                        font-size: 12px;
                        display: block;
                        font-weight: 400;
                        text-align: center;
                        line-height: 18px;
                    }
                }

                .no-identify {
                    background: #ccc url(../../assets/image/identify-ico.png) no-repeat 6px center;
                    color: #868686;
                }
            }



        }

        .data {
            width: 215px;
            margin: 0 auto;
            height: 75px;

            span {
                font-size: 14px;
                float: left;
                width: 107px;
                text-align: center;

                em {
                    font-size: 20px;
                    font-weight: 700;
                    font-family: Arial;
                    color: #f02323;
                    display: block;
                    margin-top: 10px;
                }
            }

            .st {
                width: 1px;
                height: 30px;
                background-color: #f4f4f4;
                margin-top: 21px;
            }
        }

        .org-include {
            width: 195px;
            height: 85px;
            border-top: 1px solid #f4f4f4;
            border-bottom: 1px solid #f4f4f4;
            text-align: center;
            padding: 0 10px;
            margin: 0 auto;

            h3 {
                background: #fff;
                padding: 0 5px;
                width: 60px;
                margin: -10px auto 10px auto;
                font-size: 12px;
                font-weight: 400;
            }

            p {
                font-size: 12px;
                color: #868686;
                width: 100%;
            }
        }

        .skills {
            width: 215px;
            border-top: 1px solid #f4f4f4;
            text-align: center;
            margin: 0 auto;
            margin-bottom: 5px;
            height: 60px;

            h3 {
                background: #fff;
                padding: 0 5px;
                width: 60px;
                margin: -10px auto 10px auto;
                font-size: 12px;
                font-weight: 400;
            }

            .skill-type {
                width: 170px;
                height: 36px;
                // overflow: hidden;
                margin: 0 auto;
                font-size: 0;

                span {
                    font-size: 12px;
                    color: #868686;
                    padding: 0 4px;
                }
            }
        }

        .see-now {
            display: block;
            width: 100%;
            height: 46px;
            line-height: 46px;
            text-align: center;
            color: #f0503c;
            border-top: 1px solid #f4f4f4;
        }


    }
}
</style>
